import { render } from "./TechPage.vue?vue&type=template&id=781184de&scoped=true"
import script from "./TechPage.vue?vue&type=script&lang=js"
export * from "./TechPage.vue?vue&type=script&lang=js"

import "./TechPage.vue?vue&type=style&index=0&id=781184de&scoped=true&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781184de"]])

export default __exports__
import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {Scroll});
